import { render, staticRenderFns } from "./roomInfo.vue?vue&type=template&id=5cce2725&scoped=true"
import script from "./roomInfo.vue?vue&type=script&lang=js"
export * from "./roomInfo.vue?vue&type=script&lang=js"
import style0 from "./roomInfo.vue?vue&type=style&index=0&id=5cce2725&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cce2725",
  null
  
)

export default component.exports